import {useCheckboxSelection} from "../Checkbox";
import {Button, Grid, Menu, MenuItem, TextField} from "@mui/material";
import {useState} from "react";
import {StaticDatePicker} from "@mui/x-date-pickers";
import moment, {Moment} from "moment";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useTableRefresher} from "../../../../misc/scroller/Table";
import {logisticsTableName} from "./Logistics";
import { Loader } from "../../../../misc/Loader";
import {useProjectId} from "../ProjectName";

export function BulkEditNeededBy(props: {
    type: string;
    anchorEl: HTMLElement | null;
    onOpen(): void;
}) {
    const sel = useCheckboxSelection()
    const [open, setOpen] = useState(false);
    const [value] = useState<Moment|null>(moment());
    const project = useProjectId();
    const refresher = useTableRefresher(logisticsTableName(project, props.type));

    const update = useAsyncAction(async (input: {ids: number[], due: null | Moment}) => {
        await api.logistics.bulkUpdateRequestDueDates(input);
        setOpen(false);
        refresher()
    }, [refresher]);

    return <>
        <MenuItem disabled={sel.length === 0} onClick={() => {
            props.onOpen();
            setOpen(true);
        }}>Update Needed By</MenuItem>

        {open && <Menu open anchorEl={props.anchorEl} onClose={() => setOpen(false)}>
            <Loader {...update} />
            <StaticDatePicker
                displayStaticWrapperAs="desktop"
                value={value}
                onChange={(newValue) => {
                    update.callback({
                        ids: sel,
                        due: newValue,
                    })
                }}
                renderInput={(params) => <TextField {...params} />}
            />
            <Grid container spacing={1} justifyContent="flex-end" style={{paddingRight: 10, paddingBottom: 8}}>
                <Grid item>
                    <Button onClick={() => setOpen(false)} size="small">Cancel</Button>
                </Grid>
                <Grid item>
                    <Button onClick={() => update.callback({
                        ids: sel,
                        due: null,
                    })} variant="contained" size="small">Set to Blank</Button>
                </Grid>
            </Grid>
        </Menu>}
    </>
}